import { render, staticRenderFns } from "./QuestionResult.vue?vue&type=template&id=69cfed60&scoped=true"
import script from "./QuestionResult.vue?vue&type=script&lang=ts"
export * from "./QuestionResult.vue?vue&type=script&lang=ts"
import style0 from "./QuestionResult.vue?vue&type=style&index=0&id=69cfed60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69cfed60",
  null
  
)

export default component.exports